<template>
  <div class="giftList">
    <div class="headBox">
      <div class="icon" @click="handleBack">
        <a-icon type="left" style="color: #10141a" />
      </div>
      <div class="title">赠送课程</div>
    </div>
    <div class="content">
      <div class="content-title">选择课程</div>
      <div class="search-box">
        <div class="search-item">
          <div>班型名称：</div>
          <a-input
            v-model="className"
            placeholder="请输入"
            style="width: 200px"></a-input>
        </div>
        <div class="search-item">
          <div>所属站点：</div>
          <a-select
            ref="select"
            v-model="classSite"
            style="width: 200px"
            placeholder="请选择">
            <a-select-option
              v-for="item in siteOptions"
              :value="item.id"
              :key="item.id"
              >{{ item.website_name }}</a-select-option
            >
          </a-select>
        </div>
        <div class="search-control">
          <a-button
            type="primary"
            style="margin-right: 10px"
            @click="handleSearch"
            >查询</a-button
          >
          <a-button @click="handleReset">重置</a-button>
        </div>
      </div>
      <div class="table">
        <a-table
          rowKey="key"
          size="small"
          :loading="tableLoading"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="pagination"
          :scroll="{ x: true }"
          class="sd-table-force-nowrap"
          :rowSelection="{
            fixed: true,
            selectedRowKeys: selectedRowKeys,
            onChange: onSelectChange,
            type: 'radio',
          }"
          @change="handleTableChange">
        </a-table>
      </div>
      <div class="sumbit-box">
        <a-button style="margin-right: 10px" @click="handleBack">取消</a-button>
        <a-button type="primary" @click="handleSumbit">确定</a-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  querySideBarClassTypeWebsiteList,
  querySideBarClassTypePageList,
  giftSideBarCourse,
} from "@/api/detail";
import store from "@/store";

export default {
  name: "giftList",
  props: {
    externalCustomerId: {
      type: String,
      default: "",
    },
    userInfo: {
      type: Object,
      default: () => {},
    },
  },
  components: {},
  data() {
    return {
      className: "",
      classSite: undefined,
      siteOptions: [],
      /* 分页参数 */
      pagination: {
        current: 1,
        pageSize: 10,
        // pageSizeOptions: ["10", "20", "30", "40", "50"],
        showTotal: (total, range) => `${range[0]}-${range[1]} 共${total}条`,
        showQuickJumper: false,
        // showSizeChanger: true,
        total: 10,
      },
      columns: [
        {
          title: "班型分类",
          dataIndex: "type_dictText",
          customRender: (text) => text || "-",
        },
        {
          title: "课程名称",
          dataIndex: "classTypeName",
          customRender: (text) => text || "-",
        },
        {
          title: "所属站点",
          dataIndex: "websiteName",
          customRender: (text) => text || "-",
        },
      ],
      /* table加载状态 */
      extra: {
        loading: false,
      },
      /* 数据源 */
      dataSource: [],
      /* table选中keys*/
      selectedRowKeys: [],
      selectClass: {},
      tableLoading: false,
      loadingTimer: null,
    };
  },
  computed: {},
  created() {},
  methods: {
    init() {
      this.getSiteOptions();
      this.loadData();
    },
    getSiteOptions() {
      querySideBarClassTypeWebsiteList({
        tenantId: store.getters.tenantId,
      }).then((res) => {
        this.siteOptions = res.result;
        // console.log("看看是什么", res);
      });
    },
    loadData() {
      if (this.loadingTimer) {
        clearTimeout(this.loadingTimer);
        this.loadingTimer = setTimeout(() => {
          this.tableLoading = false;
          this.loadingTimer = null;
        }, 5000);
      }
      this.tableLoading = true;
      querySideBarClassTypePageList({
        tenantId: store.getters.tenantId,
        classTypeName: this.className,
        websiteId: this.classSite,
        pageNo: this.pagination.current,
        pageSize: this.pagination.pageSize,
      }).then((res) => {
        const dataList = res.result.records;
        dataList.forEach((item, index) => {
          item.key = item.classTypeId + index;
        });
        this.dataSource = res.result.records;
        this.pagination.total = res.result.total;
        this.tableLoading = false;
        clearTimeout(this.loadingTimer);
        this.loadingTimer = null;
      });
    },
    handleSearch() {
      this.pagination.current = 1;
      this.loadData();
    },
    handleReset() {
      this.className = "";
      this.classSite = undefined;
      this.pagination.current = 1;
      this.loadData();
    },
    // 分页、排序、筛选变化时触发
    handleTableChange(pagination, filters, sorter) {
      // console.log(195, pagination);
      //   if (Object.keys(sorter).length > 0) {
      //     this.sorter.column = sorter.field;
      //     this.sorter.order = "ascend" === sorter.order ? "asc" : "desc";
      //   }
      console.log("什么东西", pagination);
      this.pagination = pagination;
      this.loadData();
    },
    // 列表多选
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
      console.log("选择的行 =======》", this.selectionRowKeys);
      console.log("选择的行对象 ======》", this.selectionRows);
      this.selectClass = selectionRows[0];
    },
    handleSumbit() {
      //  判断selectClass不为空对象
      if (Object.keys(this.selectClass).length > 0) {
        const params = {
          tenantId: store.getters.tenantId,
          corpId: store.getters.corpId,
          agreementCompanyName: this.selectClass.agreementCompanyName,
          classTypeId: this.selectClass.classTypeId,
          externalCustomerId: this.externalCustomerId,
          orderCourseWebsiteId: this.selectClass.websiteId,
          orderCourseWebsiteName: this.selectClass.websiteName,
          wechatUserId: this.userInfo.userId,
        };
        console.log("看一下", params);
        giftSideBarCourse(params).then((res) => {
          this.$message.success("赠送成功");
          setTimeout(() => {
            this.handleBack();
          }, 1000);
        });
      } else {
        this.$message.warning("请选择课程");
      }

      // giftSideBarCourse({
      //   tenantId: store.getters.tenantId,
      //   classTypeId: this.selectionRows[0].classTypeId,
      //   externalUserId: this.selectionRows[0].externalUserId,
      // }).then((res) => {
      //   console.log("赠送课程成功", res);
      // });
    },
    handleBack() {
      this.$emit("handleBack");
    },
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
.giftList {
  background-color: #f3f5fa;
  width: 100vw;
  height: 95vh;
  overflow-y: scroll;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.headBox {
  display: flex;
  height: 44px;
  width: 100vw;
  background-color: white;
}
.icon {
  height: 44px;
  width: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.title {
  display: flex;
  align-items: center;
  text-align: left;
  font-weight: 400;
  font-size: 16px;
  color: #10141a;
}
.content {
  width: 95vw;
  background-color: white;
  margin-top: 10px;
}
.content-title {
  font-size: 15px;
  font-weight: 600;
  color: #10141a;
  padding-left: 10px;
  margin-left: 10px;
  margin-top: 10px;
  border-left: #557be8 solid 3px;
}
.search-box {
  padding: 10px 0 0 10px;
}
.search-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.search-control {
  display: flex;
  justify-content: flex-end;
  margin-right: 10px;
}
.table {
  margin-top: 10px;
}
.sumbit-box {
  display: flex;
  justify-content: flex-end;
  margin-right: 10px;
  margin-bottom: 50px;
}
.sd-table-force-nowrap {
  td,
  th {
    white-space: nowrap;
  }

  .ant-table-selection-column {
    padding: 12px 22px !important;
  }

  /** 列自适应，弊端会导致列宽失效 */

  &.ant-table-wrapper .ant-table-content {
    overflow-x: auto;
  }
}
</style>
